__webpack_require__.p = "https://img0.didiglobal.com/static/manhattan_global_static/baldr-outside-app/";